import React, { useEffect } from "react";
import "./faqSection.css";
import question from "../../assets/illustrations/questions-2.png";
import questionPerson from "../../assets/illustrations/question-person.png";
import useCheckIfLarge from "../../customHooks/useCheckIfLarge";
import landlord from "../../assets/illustrations/Search2.png";
import renter from "../../assets/illustrations/Search.png";
import SEOTags from "../../utils/SEOTags";
import Layout from "../../components/layout/Layout";

const BreadcrumbListSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      item: { "@id": "https://www.vakansa.se/", name: "Hem" },
    },
    {
      "@type": "ListItem",
      position: 2,
      item: {
        "@id": `https://www.vakansa.se/fragor-och-svar`,
        name: "Frågor och svar",
      },
    },
  ],
};

function FAQ() {
  const isLarge = useCheckIfLarge();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  const landlordFAQ = () => {
    window.location.href = "/fragor-och-svar/hyresvard";
  };

  const renterFAQ = () => {
    window.location.href = "/fragor-och-svar/hyresgast";
  };

  const vakansaFAQ = () => {
    window.location.href = "/fragor-och-svar/vad-ar-vakansa";
  };

  return (
    <div className="faq-section-outer">
      <SEOTags
        title={
          "Få svar om hur du hyr och hyr ut snabbt & enkelt på Vakansa!   "
        }
        description={
          "Vill du veta vad det innebär att vara hyresvärd & hyresgäst på Vakansa? Få svar på dina vanligaste frågor snabbt & smidigt här!"
        }
        canonicalUrl={"/fragor-och-svar"}
        ogImage={"/images/logo/meta-logo.jpg"}
        structuredData={BreadcrumbListSchema}
      />
      <Layout>
        <main className="faq-section-background">
          <div className="faq-section">
            <div
              className="faq-section-top-text"
              aria-labelledby="faq-title"
              aria-describedby="faq-description"
            >
              <h1 id="faq-title">Frågor och svar</h1>
              <h2 id="faq-description">Hur kan vi hjälpa dig?</h2>
            </div>
            <div className="faq-section-flex">
              <div className="faq-section-content">
                {isLarge ? (
                  <>
                    <button
                      className="faq-section-options"
                      onClick={landlordFAQ}
                      aria-label="Vanliga frågor för hyresvärdar"
                    >
                      <img src={landlord} alt="Hus med checkbox" width={140} height={127} />
                      <p>Hyresvärd</p>
                    </button>
                    <button
                      className="faq-section-options"
                      onClick={renterFAQ}
                      aria-label="Vanliga frågor för hyresgäster"
                    >
                      <img src={renter} alt="Hus med förstorningsglas" width={140} height={127} />
                      <p>Hyresgäst</p>
                    </button>
                    <button
                      className="faq-section-options"
                      onClick={vakansaFAQ}
                      aria-label="Vanliga frågor    om Vakansa"
                    >
                      <img src={question} alt="Bild på frågetecken" height={127} width={127} />
                      <p>Vad är vakansa?</p>
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      className="faq-section-options"
                      id="faq-item-1"
                      onClick={vakansaFAQ}
                    >
                      <img src={question} alt="Bild på frågetecken" height={127} width={127}/>
                      <p>Vad är Vakansa?</p>
                    </button>
                    <div className="faq-option-flex">
                      <button
                        className="faq-section-options"
                        onClick={landlordFAQ}
                      >
                        <img src={landlord} alt="Hus med checkbox" width={140} height={127} />
                        <p>Hyresvärd</p>
                      </button>
                      <button className="faq-section-options" onClick={renterFAQ}>
                        <img src={renter} alt="Hus med förstorningsglas" width={140} height={127} />
                        <p>Hyresgäst</p>
                      </button>
                    </div>
                  </>
                )}
              </div>
              <div className="faq-background-img">
                <img
                  src={questionPerson}
                  width={500}
                  height={411}
                  alt="Illustration av en kvinna med brunt hår som håller en smartphone och vilar hakan mot handen, med ett orange frågetecken ovanför huvudet som symboliserar nyfikenhet."
                />
              </div>
            </div>
          </div>
        </main>
      </Layout>
    </div>
  );
}

export default FAQ;
